import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { sessionSetItemStr } from '../../utils/sessionHelpers'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'

export default function SubprojectExpenseRecordInfo(props) {
  const [formSchema, setFormSchema] = useState(props.schema)

  useEffect(() => {
    const _projectEndDate = formSchema?.projectEndDate
      ? moment(formSchema?.projectEndDate).format(DATE_FORMAT)
      : ''
    const _projectStartDate = formSchema?.projectStartDate
      ? moment(formSchema?.projectStartDate).format(DATE_FORMAT)
      : ''
    sessionSetItemStr('projectEndDate', _projectEndDate || '')
    sessionSetItemStr('projectStartDate', _projectStartDate || '')
  }, [formSchema])

  return (
    <>
      <Panel
        bordered
        style={{
          backgroundColor: '#cccbca4d',
          border: '1px solid #4e4b488c',
        }}
      >
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>รหัสโครงการหลัก : </b> {formSchema?.projectCode || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>เลขที่ข้อตกลง : </b> {formSchema?.contractNo || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>ชื่อโครงการหลัก : </b> {formSchema?.projectName || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>สำนัก : </b> {formSchema?.coordinator || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>ระยะเวลาดำเนินงาน : </b>{' '}
            {formSchema?.duration ? `วันที่ ${formSchema?.duration}` : ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>ผู้รับผิดชอบโครงการ : </b> {formSchema?.responsibler || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>รหัสโครงการย่อย : </b> {formSchema?.subProjectCode || ''}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>สถานะโครงการย่อย : </b> {formSchema?.projectStatus || ''}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24}>
            <b>ชื่อโครงการย่อย : </b> {formSchema?.subProjectName || ''}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
